import { atom } from 'jotai'

import type { LifecycleState, PersistenceState } from '../../../utilities'
import { atomWithListeners } from '../../../utilities'
import { ConformedBranding, MediaAsset } from '../../../views'

export const brandLibraryAtom = atom<ConformedBranding[]>([])
export const [brandLibraryActiveAtom, useBrandLibraryActiveListener] = atomWithListeners(false)
export const brandLibraryLoadingAtom = atom(true)

// the following are all specific to a particular brand ID, and should be cleared when that changes.
export const [expandedBrandingIdAtom, useExpandedBrandingIdListener] = atomWithListeners<string | null>(null)
export const [expandedBrandingAtom, useExpandedBrandingListener] = atomWithListeners<ConformedBranding | undefined>({
	id: '',
	name: null,
	logoId: '',
	logo: undefined,
	foreground: '#FFFFFF',
	background: '#4D008C',
	accentForeground: '#FFFFFF',
	accentBackground: '#33CC66',
	toneOfVoice: '',
	visualGuidance: '',
	website: '',
	bodyFont: '',
	titleFont: '',
	generateKeyImage: true,
})
export const expandedBrandingStatusAtom = atom<LifecycleState>('idle')
export const expandedBrandingSavingAtom = atom<PersistenceState>('idle')
export const expandedBrandingScanErrorAtom = atom<string | null>(null)
export const expandedBrandingUrlCallbackAtom = atom<
	((url: string, onSuccess: () => void, onError: (errorKey: string) => void) => void) | null
>(null)
export const newBrandingCallbackAtom = atom<((onSuccess: (brandingId: string) => void) => void) | null>(null)

export const expandedBrandingLogoCallbackAtom = atom<
	((logo: File, onSuccess: (media: MediaAsset) => void, onFail?: () => void) => void) | null
>(null)

export const deleteBrandingCallbackAtom = atom<
	((brandingId: string, onSuccess: () => void) => void) | null
>(null)

export const deletingBrandingIdAtom = atom<string | null>(null)
